/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * NEXMAIL (Internal)
 * Internal API consumed by the nexmail dashboard.
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  EmailDocumentTemplateListResponseDto,
  EmailDocumentTemplateResponseDto,
  EmailDocumentTemplatesControllerListParams,
  FillEmailDocumentTemplateDto,
  FillEmailDocumentTemplateResponseDto,
  UseEmailDocumentTemplateDto,
  UseEmailDocumentTemplateResponseDto,
} from '.././models';

import { authFetch } from '../../../../lib/api';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List email document templates
 */
export const emailDocumentTemplatesControllerList = (
  orgId: string,
  clientId: string,
  params?: EmailDocumentTemplatesControllerListParams,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<EmailDocumentTemplateListResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/email-document-templates`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getEmailDocumentTemplatesControllerListQueryKey = (
  orgId?: string,
  clientId?: string,
  params?: EmailDocumentTemplatesControllerListParams
) => {
  return [
    `/api/v1/organizations/${orgId}/clients/${clientId}/email-document-templates`,
    ...(params ? [params] : []),
  ] as const;
};

export const getEmailDocumentTemplatesControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof emailDocumentTemplatesControllerList>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params?: EmailDocumentTemplatesControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailDocumentTemplatesControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getEmailDocumentTemplatesControllerListQueryKey(orgId, clientId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof emailDocumentTemplatesControllerList>>
  > = ({ signal }) =>
    emailDocumentTemplatesControllerList(orgId, clientId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(orgId && clientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof emailDocumentTemplatesControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EmailDocumentTemplatesControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof emailDocumentTemplatesControllerList>>
>;
export type EmailDocumentTemplatesControllerListQueryError = unknown;

export function useEmailDocumentTemplatesControllerList<
  TData = Awaited<ReturnType<typeof emailDocumentTemplatesControllerList>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params: undefined | EmailDocumentTemplatesControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailDocumentTemplatesControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof emailDocumentTemplatesControllerList>>,
          TError,
          Awaited<ReturnType<typeof emailDocumentTemplatesControllerList>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEmailDocumentTemplatesControllerList<
  TData = Awaited<ReturnType<typeof emailDocumentTemplatesControllerList>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params?: EmailDocumentTemplatesControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailDocumentTemplatesControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof emailDocumentTemplatesControllerList>>,
          TError,
          Awaited<ReturnType<typeof emailDocumentTemplatesControllerList>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEmailDocumentTemplatesControllerList<
  TData = Awaited<ReturnType<typeof emailDocumentTemplatesControllerList>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params?: EmailDocumentTemplatesControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailDocumentTemplatesControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List email document templates
 */

export function useEmailDocumentTemplatesControllerList<
  TData = Awaited<ReturnType<typeof emailDocumentTemplatesControllerList>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params?: EmailDocumentTemplatesControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailDocumentTemplatesControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEmailDocumentTemplatesControllerListQueryOptions(
    orgId,
    clientId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get a single template
 */
export const emailDocumentTemplatesControllerGetOne = (
  orgId: string,
  clientId: string,
  id: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<EmailDocumentTemplateResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/email-document-templates/${id}`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getEmailDocumentTemplatesControllerGetOneQueryKey = (
  orgId?: string,
  clientId?: string,
  id?: string
) => {
  return [
    `/api/v1/organizations/${orgId}/clients/${clientId}/email-document-templates/${id}`,
  ] as const;
};

export const getEmailDocumentTemplatesControllerGetOneQueryOptions = <
  TData = Awaited<ReturnType<typeof emailDocumentTemplatesControllerGetOne>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailDocumentTemplatesControllerGetOne>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getEmailDocumentTemplatesControllerGetOneQueryKey(orgId, clientId, id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof emailDocumentTemplatesControllerGetOne>>
  > = ({ signal }) =>
    emailDocumentTemplatesControllerGetOne(orgId, clientId, id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(orgId && clientId && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof emailDocumentTemplatesControllerGetOne>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EmailDocumentTemplatesControllerGetOneQueryResult = NonNullable<
  Awaited<ReturnType<typeof emailDocumentTemplatesControllerGetOne>>
>;
export type EmailDocumentTemplatesControllerGetOneQueryError = unknown;

export function useEmailDocumentTemplatesControllerGetOne<
  TData = Awaited<ReturnType<typeof emailDocumentTemplatesControllerGetOne>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailDocumentTemplatesControllerGetOne>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof emailDocumentTemplatesControllerGetOne>>,
          TError,
          Awaited<ReturnType<typeof emailDocumentTemplatesControllerGetOne>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEmailDocumentTemplatesControllerGetOne<
  TData = Awaited<ReturnType<typeof emailDocumentTemplatesControllerGetOne>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailDocumentTemplatesControllerGetOne>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof emailDocumentTemplatesControllerGetOne>>,
          TError,
          Awaited<ReturnType<typeof emailDocumentTemplatesControllerGetOne>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEmailDocumentTemplatesControllerGetOne<
  TData = Awaited<ReturnType<typeof emailDocumentTemplatesControllerGetOne>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailDocumentTemplatesControllerGetOne>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a single template
 */

export function useEmailDocumentTemplatesControllerGetOne<
  TData = Awaited<ReturnType<typeof emailDocumentTemplatesControllerGetOne>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailDocumentTemplatesControllerGetOne>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEmailDocumentTemplatesControllerGetOneQueryOptions(
    orgId,
    clientId,
    id,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Instantiate a template into a new draft under this client. Resolves $brand.defaultHeader / $brand.defaultFooter placeholders against the client's active default sections so the persisted draft has inline header/footer the user can edit. Other merge tags ($brand.*, $slot.*, [NM:*]) remain unresolved and are filled at compile/send time.
 */
export const emailDocumentTemplatesControllerUse = (
  orgId: string,
  clientId: string,
  id: string,
  useEmailDocumentTemplateDto: UseEmailDocumentTemplateDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<UseEmailDocumentTemplateResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/email-document-templates/${id}/use`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: useEmailDocumentTemplateDto,
      signal,
    },
    options
  );
};

export const getEmailDocumentTemplatesControllerUseMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof emailDocumentTemplatesControllerUse>>,
    TError,
    { orgId: string; clientId: string; id: string; data: UseEmailDocumentTemplateDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof emailDocumentTemplatesControllerUse>>,
  TError,
  { orgId: string; clientId: string; id: string; data: UseEmailDocumentTemplateDto },
  TContext
> => {
  const mutationKey = ['emailDocumentTemplatesControllerUse'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof emailDocumentTemplatesControllerUse>>,
    { orgId: string; clientId: string; id: string; data: UseEmailDocumentTemplateDto }
  > = (props) => {
    const { orgId, clientId, id, data } = props ?? {};

    return emailDocumentTemplatesControllerUse(orgId, clientId, id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmailDocumentTemplatesControllerUseMutationResult = NonNullable<
  Awaited<ReturnType<typeof emailDocumentTemplatesControllerUse>>
>;
export type EmailDocumentTemplatesControllerUseMutationBody = UseEmailDocumentTemplateDto;
export type EmailDocumentTemplatesControllerUseMutationError = unknown;

/**
 * @summary Instantiate a template into a new draft under this client. Resolves $brand.defaultHeader / $brand.defaultFooter placeholders against the client's active default sections so the persisted draft has inline header/footer the user can edit. Other merge tags ($brand.*, $slot.*, [NM:*]) remain unresolved and are filled at compile/send time.
 */
export const useEmailDocumentTemplatesControllerUse = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof emailDocumentTemplatesControllerUse>>,
      TError,
      { orgId: string; clientId: string; id: string; data: UseEmailDocumentTemplateDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof emailDocumentTemplatesControllerUse>>,
  TError,
  { orgId: string; clientId: string; id: string; data: UseEmailDocumentTemplateDto },
  TContext
> => {
  const mutationOptions = getEmailDocumentTemplatesControllerUseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Fill a library template using an agentic worker + critic. Returns the resolved EmailDocument plus the slot map and a critic verdict. Does NOT persist — the caller previews the result and then calls /use with documentOverride to create a draft.
 */
export const emailDocumentTemplatesControllerFill = (
  orgId: string,
  clientId: string,
  id: string,
  fillEmailDocumentTemplateDto: FillEmailDocumentTemplateDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<FillEmailDocumentTemplateResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/email-document-templates/${id}/fill`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: fillEmailDocumentTemplateDto,
      signal,
    },
    options
  );
};

export const getEmailDocumentTemplatesControllerFillMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof emailDocumentTemplatesControllerFill>>,
    TError,
    { orgId: string; clientId: string; id: string; data: FillEmailDocumentTemplateDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof emailDocumentTemplatesControllerFill>>,
  TError,
  { orgId: string; clientId: string; id: string; data: FillEmailDocumentTemplateDto },
  TContext
> => {
  const mutationKey = ['emailDocumentTemplatesControllerFill'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof emailDocumentTemplatesControllerFill>>,
    { orgId: string; clientId: string; id: string; data: FillEmailDocumentTemplateDto }
  > = (props) => {
    const { orgId, clientId, id, data } = props ?? {};

    return emailDocumentTemplatesControllerFill(orgId, clientId, id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmailDocumentTemplatesControllerFillMutationResult = NonNullable<
  Awaited<ReturnType<typeof emailDocumentTemplatesControllerFill>>
>;
export type EmailDocumentTemplatesControllerFillMutationBody = FillEmailDocumentTemplateDto;
export type EmailDocumentTemplatesControllerFillMutationError = unknown;

/**
 * @summary Fill a library template using an agentic worker + critic. Returns the resolved EmailDocument plus the slot map and a critic verdict. Does NOT persist — the caller previews the result and then calls /use with documentOverride to create a draft.
 */
export const useEmailDocumentTemplatesControllerFill = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof emailDocumentTemplatesControllerFill>>,
      TError,
      { orgId: string; clientId: string; id: string; data: FillEmailDocumentTemplateDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof emailDocumentTemplatesControllerFill>>,
  TError,
  { orgId: string; clientId: string; id: string; data: FillEmailDocumentTemplateDto },
  TContext
> => {
  const mutationOptions = getEmailDocumentTemplatesControllerFillMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
